<template>
	<router-view>
	</router-view>
</template>

<script>
	export default {
		name: "ReadOnlyView",
	};
</script>

<style scoped>

</style>
